export default __webpack_public_path__ + "static/mailchimp-8c54a0a198ba4aa608f0475b7269bf93.svg";